import React, { useRef } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import moment from "moment";
import { useMpcLargeModalSize } from "./mpcLargeModal";

const formatNoteDate = (value) => {
  if (!value) return "—";
  return moment(value).format("MMM D, YYYY h:mm A");
};

const MonthlyPhoneNotesModal = ({
  isOpen,
  toggle,
  patient,
  notes: notesProp,
  titlePrefix = "Monthly phone notes",
  emptyMessage = "No monthly phone notes for this period.",
  tone = "neutral",
  consultationNoteTitle = "Monthly Phone Consultation"
}) => {
  const notes = notesProp || patient?.monthlyPhoneNotes || [];
  const patientName = patient?.patientName || "Patient";
  const modalRef = useRef(null);

  useMpcLargeModalSize(isOpen, modalRef);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      innerRef={modalRef}
      className={`mpc-large-modal mpc-notes-modal mpc-notes-modal--${tone}`}
      dialogClassName="mpc-large-modal-dialog"
      contentClassName="mpc-large-modal-content"
    >
      <ModalHeader toggle={toggle}>
        <span className="mpc-notes-title-prefix">{titlePrefix}</span>
        <span className="mpc-notes-title-sep"> — </span>
        <span className="mpc-notes-title-patient">{patientName}</span>
        <small className="d-block text-muted mt-1 fw-normal">
          <span className="mpc-notes-count-chip">{notes.length}</span>{" "}
          note{notes.length === 1 ? "" : "s"} in selected period
        </small>
      </ModalHeader>
      <ModalBody>
        {notes.length === 0 ? (
          <div className="mpc-notes-empty">{emptyMessage}</div>
        ) : (
          <ul className="mpc-notes-list">
            {notes.map((note) => (
              <li key={note._id || `${note.subject}-${note.createdAt}`} className="mpc-notes-item">
                <div className="mpc-notes-item-head">
                  <span className="mpc-notes-subject">{(note.subject && note.subject.toLowerCase() !== 'false') ? note.subject : (consultationNoteTitle || 'Monthly Phone Consultation')}</span>
                  <span className="mpc-notes-meta">
                    {formatNoteDate(note.createdAt || note.messageDate)}
                    {note.createdByName ? ` · ${note.createdByName}` : ""}
                  </span>
                </div>
                <div className="mpc-notes-body">{note.body || "—"}</div>
              </li>
            ))}
          </ul>
        )}
      </ModalBody>
    </Modal>
  );
};

export default MonthlyPhoneNotesModal;
